import {
  CURRENT_SUBSCRIPTION_FEATURE_KEY,
  CurrentSubscriptionState,
} from './current/current.state';
import {
  SUBSCRIPTION_PRODUCTS_FEATURE_KEY,
  SubscriptionProductsState,
} from './products/products.state';

export interface SubscriptionState {
  [SUBSCRIPTION_PRODUCTS_FEATURE_KEY]: SubscriptionProductsState;
  [CURRENT_SUBSCRIPTION_FEATURE_KEY]: CurrentSubscriptionState;
}

export const SUBSCRIPTION_FEATURE_KEY = 'subscription';
